import { baseURL } from "../config";

export class UserModel {
    constructor(data = {}) {
        this.id = data.id ?? null
        this.username = data.username ?? null
        this.password = data.password ?? null
        this.email = data.email ?? null
        this.first_name = data.first_name ?? null
        this.full_name = data.full_name ?? null
        this.file = null
        this.last_name = data.last_name ?? null
        this.mobile_no = data.mobile_no ?? null
        this.roles = (data.roles) ? data.roles[0] : {}
        this.is_superuser = data.is_superuser ?? null
        this.is_editable = data.is_editable ?? true
        this.profile_image = (data.profile_image) ? (baseURL + "" + data.profile_image) : "https://picsum.photos/200/300"
        this.created_at = new Date(data.created_at).toLocaleString("en-GB", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        }) ?? "";
        this.updated_at = new Date(data.updated_at).toLocaleString("en-GB", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        }) ?? "";
    }

    toFormData() {
        const formdata = new FormData()
        // const rolData = this.roles.map(rol => ({
        //     id: rol.id,
        //     name: rol.name,
        // }))
        if (this.username) formdata.append("username", this.username)
        if (this.password) formdata.append("password", this.password)
        if (this.email) formdata.append("email", this.email)
        if (this.file) formdata.append("profile_image", this.file)
        if (this.first_name) formdata.append("first_name", this.first_name)
        if (this.last_name) formdata.append("last_name", this.last_name)
        if (this.roles.length != 0) formdata.append("roles", this.roles)
        if (this.mobile_no) formdata.append("mobile_no", this.mobile_no)
        // if (this.is_superuser) formdata.append("is_superuser", true)
        return formdata
    }
}

export class TokenModel {
    constructor(data = {}) {
        this.access = data.access
        this.refresh = data.refresh
    }
}